<script>
  export let klass = "";
</script>

<div class="{klass}">
  <slot />
</div>

<style type="text/scss">
  div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /* width: fit-content; */    
    &:not(:first-child){
      border-top: 2px solid var(--primary-bright);
    }
    > :global(*) {
      /* margin-left: var(--gap-xs); */
      flex-grow: 1;
      &:not(:last-child){
        /* padding-right: calc( 2 * var(--gap-m)); */
        border-right: 2px solid var(--primary-bright);
      }
      &:last-child:not(.full-width) {
        width: auto;
      }
    }
    :global(& + div) {
    }
  }
</style>